import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { HelpersService } from "../../services/tools/helpers.service";
import { ErrorModalComponent } from '../../components/tools/modals/error-modal/error-modal.component';
import { GastosService } from '../../services/gastos.service';
import { CategoriasGastosService } from '../../services/categorias-gastos.service';
import { SubcategoriasGastosService } from '../../services/subcategorias-gastos.service';
import { SucursalesService } from '../../services/sucursales.service';

declare var $;

@Component({
  selector: 'app-gastos-modal',
  templateUrl: './gastos-modal.component.html',
  styleUrls: ['./gastos-modal.component.scss']
})
export class GastosModalComponent implements OnInit {

  @ViewChild(ErrorModalComponent) errorModal: ErrorModalComponent;

  selected: any = {};
  errors: any = {};
  processing: boolean = false;
  isUpdate: boolean = false;
  categoriaSelected: any = {};
  categoriasFilterOptions: any[];
  subcategoriaSelected: any = {};
  subcategoriasFilterOptions: any[];
  sucursalesFilterOptions: any[];
  sucursalesSelected: any = {};

  public sucursalPorDefecto: string = "";


  @Output() public goToCallback: EventEmitter<string> = new EventEmitter;

  constructor(  private gastosService: GastosService,
                private categoriasService: CategoriasGastosService,
                private sucursalesService: SucursalesService,
                private subcategoriasService: SubcategoriasGastosService,
                private helperService: HelpersService,
    ) {
    
  }

  ngOnInit() {
    this.selected = this.gastosService.getDefaultSchedule();
    this.categoriaSelected = this.categoriasService.getDefaultSchedule();
    this.subcategoriaSelected = this.subcategoriasService.getDefaultSchedule();
    this.sucursalesSelected = this.sucursalesService.getDefaultSchedule();
    this.getSucursales();
    this.getCategorias();
  }

  getSucursales(){
    this.sucursalesService.getSelect().subscribe(
      (response)=>{
        this.sucursalesFilterOptions = response.json().content;
        if (this.sucursalesFilterOptions.length>1){
          this.sucursalPorDefecto = "Seleccione";
        } else if(this.sucursalesFilterOptions.length>0){
          this.sucursalesSelected =  this.sucursalesFilterOptions[0];
        }
      }, error => {
        this.processing = false;

        // se resuelven los errores 403 y 500
        this.helperService.httpGlobalError(error, false);

        if (error.status == 400 || error.status == 500) {
          this.helperService.notification('ERROR', 'Sucedió un error obtener el listado de sucursales. Por favor, intenta más tarde.', 'error');
        }
    });
  }

  getCategorias(){
    this.categoriasService.getSelect().subscribe(
      (response)=>{
        this.categoriasFilterOptions = response.json().content;
      }, error => {
        this.processing = false;

        // se resuelven los errores 403 y 500
        this.helperService.httpGlobalError(error, false);

        if (error.status == 400 || error.status == 500) {
          this.helperService.notification('ERROR', 'Sucedió un error obtener el listado de categorías. Por favor, intenta más tarde.', 'error');
        }
    });
  }

  getSubcategorias(){
    this.subcategoriasService.getSelect(this.categoriaSelected.id).subscribe(
      (response)=>{
        this.subcategoriasFilterOptions = response.json().content;
      }, error => {
        this.processing = false;

        // se resuelven los errores 403 y 500
        this.helperService.httpGlobalError(error, false);

        if (error.status == 400 || error.status == 500) {
          this.helperService.notification('ERROR', 'Sucedió un error obtener el listado de subcategorías. Por favor, intenta más tarde.', 'error');
        }
    });
  }


  reset() {
    this.selected = {};
    this.isUpdate = false;
    this.errors = {};
    this.categoriaSelected = {};
  }

  close(){
    $('#usuarios-modal').modal('hide');
  }

  open(user) {
    this.reset();
    if(user !== undefined && user !== null)
    {
      this.selected = user;
      this.selected.password = '123456';
      this.isUpdate = true;
    } 
    $('#usuarios-modal').modal('show');
  }


  onKeyup($event) {
    if($event.key == 'Enter') {
      this.accept();
    }
  }

  changeSucursalesSelected(selected) {
    this.sucursalesSelected = selected;
  }

  changeCategoriasSelected(selected) {
    this.categoriaSelected = selected;
    this.getSubcategorias();
  }

  changeSubcategoriasSelected(selected) {
    this.subcategoriaSelected = selected;
  }


  accept() {
    this.errors = [];
    if(this.sucursalesSelected.length < 1){
      this.selected.idSucursales = "";
    }
    else
    {
      this.selected.idSucursales = this.sucursalesSelected.id;
    }
    if(this.subcategoriaSelected.length < 1){
      this.selected.idSubcategoriasGastos = "";
    }
    else
    {
      this.selected.idSubcategoriasGastos = this.subcategoriaSelected.id;
    }
    this.errors = this.gastosService.validate(this.selected);
    
    if(!$.isEmptyObject(this.errors)){
      return false;
    }

    this.processing = true;
    
    if(this.isUpdate)
      this.update();
    else
      this.create();
    
  }

  create(){
    this.gastosService.create(this.selected)
      .subscribe(response => {
        const respuesta = response.json();
        this.processing = false;
        if (respuesta.success) {
          this.helperService.notification('Gasto creado', 'Se ha creado exitosamente el gasto', 'success');
          this.goToCallback.emit('reload'); // when we emit, we reload the liquidation list
          this.close();
          //setTimeout(() => {window.location.reload()},3000);
        }
      }, error => {
        this.processing = false;
        if(error.status == 400) {
          this.showServicesErrors(error.json().content);
        }else{
          this.close();
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
        
        // se resuelven los errores 403 y 500
        this.helperService.httpGlobalError(error, false);
      });
  }

  update() {
    this.gastosService.update(this.selected, this.selected.id)
      .subscribe(response => {
        this.processing = false;
        if (response.json().success) {
          this.helperService.notification('Usuario actualizado', 'Se ha actualizado exitosamente el usuario: ' + this.selected.nombre, 'success');
          this.goToCallback.emit('reload'); 
          this.close();
        }
      }, error => {
        this.processing = false;

        if(error.status == 400) {
          this.showServicesErrors(error.json().content);
        }else{
          this.close();
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }

        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);
    });
  }

  private showServicesErrors(errors:any[]){
    //Es posible que en algún momento se necesiten parsear los errores ya que las llaves del backend,
    //no correspondan con las llaves de los errores del front
    this.errors = errors;
  }
}



// WEBPACK FOOTER //
// ./src/app/gastos/gastos-modal/gastos-modal.component.ts